export default __webpack_public_path__ + "static/media/Firebird-PREA-Final-Report-2024.72af36eb.pdf";